<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <div class="row">
      <div class="col-md-12">
        <div class="nav-align-top">
          <ul class="nav nav-pills flex-column flex-md-row mb-6 gap-2 gap-lg-0">
            <li class="nav-item" v-for="tab in tabs" :key="tab.id">
              <a
                class="nav-link"
                href="javascript:void(0);"
                v-if="tab.privilege"
                :class="{ active: activeTab === tab.id }"
                @click="setActiveTab(tab.id)"
              >
                <i :class="tab.icon + ' ti-sm me-1_5'"></i>
                {{ tab.label }}
              </a>
            </li>
          </ul>
        </div>

        <div
          class="row"
          v-show="activeTab === 'system'"
          v-if="hasPrivilege('settings_view_settings')"
        >
          <div class="col-12">
            <div class="card mb-6">
              <div class="card-body mt-4">
                <div
                  class="d-flex justify-content-center flex-md-row flex-column gap-14"
                >
                  <div
                    class="d-flex align-items-center justify-content-center align-items-sm-center gap-6"
                  >
                    <img
                      v-if="setting.network_logo"
                      :src="server_url + setting.network_logo"
                      alt="user-avatar"
                      class="d-block h-px-100 company-logo-dark"
                      id="uploadedAvatar"
                    />
                    <img
                      v-else-if="currentImageUrl"
                      :src="currentImageUrl"
                      alt="user-avatar"
                      class="d-block h-px-100 company-logo-dark"
                      id="uploadedAvatar"
                    />
                    <img
                      v-else
                      src="@/assets/img/company-logo-dark.svg"
                      alt="user-avatar"
                      class="d-block h-px-100 company-logo-dark"
                      id="uploadedAvatar"
                    />
                    <div
                      class="button-wrapper"
                      v-if="hasPrivilege('settings_update_settings')"
                    >
                      <label
                        for="upload"
                        class="btn btn-primary me-3 mb-4"
                        tabindex="0"
                      >
                        <span class="d-none d-sm-block">{{
                          $t("settings.upload_new_logo")
                        }}</span>
                        <i class="ti ti-upload d-block d-sm-none"></i>
                        <input
                          type="file"
                          id="upload"
                          ref="imageFile"
                          @change="selectImage"
                          class="account-file-input"
                          hidden
                          accept="image/png, image/jpeg"
                          v-if="hasPrivilege('settings_update_settings')"
                        />
                      </label>
                      <div>{{ $t("settings.allowed_jpg_svg_png") }}</div>
                    </div>
                  </div>
                  <!-- <div
                    class="d-flex align-items-center justify-content-center align-items-sm-center gap-6"
                  >
                    <img
                      src="@/assets/img/company-logo-light.svg"
                      alt="user-avatar"
                      class="d-block h-px-100 company-logo"
                      id="uploadedAvatar"
                    />
                    <div class="button-wrapper">
                      <label
                        for="upload"
                        class="btn btn-primary me-3 mb-4"
                        tabindex="0"
                      >
                        <span class="d-none d-sm-block">{{
                          $t("settings.upload_new_logo")
                        }}</span>
                        <i class="ti ti-upload d-block d-sm-none"></i>
                        <input
                          type="file"
                          id="upload"
                          class="account-file-input"
                          hidden
                          accept="image/png, image/jpeg"
                        />
                      </label>
                      <div>{{ $t("settings.allowed_jpg_svg_png") }}</div>
                    </div>
                  </div> -->
                </div>
              </div>
              <div class="card-body">
                <form
                  id="formNetworkSettings"
                  method="GET"
                  onsubmit="return false"
                >
                  <div class="row">
                    <div class="col-12 col-md-6 mb-4">
                      <label class="form-label" for="networkName">{{
                        $t("settings.network_name")
                      }}</label>
                      <div class="input-group">
                        <div class="input-group-text">
                          <i class="ti ti-wifi"></i>
                        </div>
                        <input
                          type="text"
                          id="networkName"
                          name="networkName"
                          class="form-control"
                          :placeholder="$t('settings.network_name')"
                          v-model="setting.network_name"
                        />
                      </div>
                    </div>

                    <div class="col-12 col-md-6 mb-4">
                      <label class="form-label" for="timezone">{{
                        $t("settings.time_zone")
                      }}</label>
                      <div class="input-group">
                        <div class="input-group-text">
                          <i class="ti ti-world"></i>
                        </div>
                        <select
                          v-model="setting.time_zone"
                          id="timezone"
                          class="form-select"
                        >
                          <option
                            v-for="zone in [
                              { name: 'Istanbul', id: 'Europe/Istanbul' },
                              { name: 'Damascus', id: 'Asia/Damascus' },
                            ]"
                            v-bind:key="zone.id"
                            :value="zone.id"
                          >
                            {{ zone.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-12 col-md-6 mb-4">
                      <label class="form-label" for="currency">{{
                        $t("settings.currency")
                      }}</label>
                      <div class="input-group">
                        <div class="input-group-text">
                          <i class="ti ti-currency-dollar"></i>
                        </div>
                        <select
                          v-model="setting.currency"
                          id="currency"
                          class="form-select"
                        >
                          <option
                            v-for="currency in [
                              { name: $t('currencies.usd'), id: '$' },
                              { name: $t('currencies.tr'), id: '₺' },
                              { name: $t('currencies.syp'), id: 'SYP' },
                              { name: $t('currencies.iqd'), id: 'IQD' },
                              { name: $t('currencies.jd'), id: 'JD' },
                              { name: $t('currencies.lbp'), id: 'LBP' },
                              { name: $t('currencies.egp'), id: 'EGP' },
                              { name: $t('currencies.sar'), id: 'SAR' },
                              { name: $t('currencies.sud'), id: 'SDG' },
                              { name: $t('currencies.mad'), id: 'MAD' },
                            ]"
                            v-bind:key="currency.id"
                            :value="currency.id"
                          >
                            {{ currency.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-12 col-md-6 mb-4">
                      <label class="form-label" for="language">{{
                        $t("settings.default_language")
                      }}</label>
                      <div class="input-group">
                        <div class="input-group-text">
                          <i class="ti ti-language"></i>
                        </div>
                        <select
                          v-model="setting.language"
                          id="language"
                          class="form-select"
                        >
                          <option
                            v-for="language in [
                              { name: 'English', id: 'en' },
                              { name: 'العربية', id: 'ar' },
                              { name: 'Türkçe', id: 'tr' },
                            ]"
                            v-bind:key="language.id"
                            :value="language.id"
                          >
                            {{ language.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div
                      v-if="settings.features.backups"
                      class="col-12 col-md-6 mb-4"
                    >
                      <label class="form-label d-block">{{
                        $t("settings.auto_backup")
                      }}</label>
                      <div class="d-flex gap-2">
                        <button
                          type="button"
                          class="btn w-100"
                          :class="
                            setting.auto_backup
                              ? 'btn-success'
                              : 'btn-outline-success'
                          "
                          @click="setAutoBackup(true)"
                        >
                          <i class="ti ti-square-check me-1"></i>
                          {{ $t("control.enabled") }}
                        </button>
                        <button
                          type="button"
                          class="btn w-100"
                          :class="
                            !setting.auto_backup
                              ? 'btn-danger'
                              : 'btn-outline-danger'
                          "
                          @click="setAutoBackup(false)"
                        >
                          <i class="ti ti-square-x me-1"></i>
                          {{ $t("control.disabled") }}
                        </button>
                      </div>

                      <input
                        type="hidden"
                        name="auto_backup"
                        :value="setting.auto_backup ? 'enabled' : 'disabled'"
                      />
                    </div>

                    <div class="col-12 col-md-6 mb-4">
                      <label class="form-label" for="accountResetTime">{{
                        $t("settings.default_expiration_hour")
                      }}</label>
                      <div class="input-group">
                        <div class="input-group-text">
                          <i class="ti ti-clock"></i>
                        </div>
                        <select
                          v-model="setting.default_expiration_hour"
                          id="accountResetTime"
                          class="form-select"
                        >
                          <option
                            v-for="unit in [
                              { name: '00:00', id: '0' },
                              { name: '01:00', id: '1' },
                              { name: '02:00', id: '2' },
                              { name: '03:00', id: '3' },
                              { name: '04:00', id: '4' },
                              { name: '05:00', id: '5' },
                              { name: '06:00', id: '6' },
                              { name: '07:00', id: '7' },
                              { name: '08:00', id: '8' },
                              { name: '09:00', id: '9' },
                              { name: '10:00', id: '10' },
                              { name: '11:00', id: '11' },
                              { name: '12:00', id: '12' },
                              { name: '13:00', id: '13' },
                              { name: '14:00', id: '14' },
                              { name: '15:00', id: '15' },
                              { name: '16:00', id: '16' },
                              { name: '17:00', id: '17' },
                              { name: '18:00', id: '18' },
                              { name: '19:00', id: '19' },
                              { name: '20:00', id: '20' },
                              { name: '21:00', id: '21' },
                              { name: '22:00', id: '22' },
                              { name: '23:00', id: '23' },
                              { name: $t('control.none'), id: '-1' },
                            ]"
                            v-bind:key="unit.id"
                            :value="unit.id"
                          >
                            {{ unit.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-12 col-md-6 mb-4">
                      <label class="form-label" for="balancePageUrl">{{
                        $t("settings.balance_page_url")
                      }}</label>
                      <div class="input-group">
                        <div class="input-group-text">
                          <i class="ti ti-link"></i>
                        </div>
                        <input
                          type="text"
                          id="balancePageUrl"
                          name="balancePageUrl"
                          class="form-control"
                          placeholder="https://..."
                          v-model="setting.status_url"
                        />
                      </div>
                    </div>

                    <div class="col-12 col-md-6 mb-4">
                      <label class="form-label" for="contactNumber">{{
                        $t("settings.contact_number")
                      }}</label>
                      <div class="input-group">
                        <div class="input-group-text">
                          <i class="ti ti-phone"></i>
                        </div>
                        <input
                          type="text"
                          id="contactNumber"
                          name="contactNumber"
                          class="form-control"
                          placeholder="+90..."
                          v-model="setting.phone_number"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div v-if="settings.features.ssra" class="col-12">
            <div class="card mb-6">
              <div class="card-body">
                <form method="GET" onsubmit="return false">
                  <div class="row">
                    <h4 class="mt-4">
                      {{ $t("settings.mobile_app_settings") }}
                    </h4>
                    <div class="col-12 col-md-6 mb-4">
                      <label class="form-label d-block">{{
                        $t("settings.allow_password_change")
                      }}</label>
                      <div class="d-flex gap-2 mt-2">
                        <button
                          type="button"
                          class="btn w-100"
                          :class="
                            setting.ssr_account_password_change
                              ? 'btn-success'
                              : 'btn-outline-success'
                          "
                          @click="setAllowPasswordChange(true)"
                        >
                          <i class="ti ti-lock-check me-1"></i>
                          {{ $t("control.enabled") }}
                        </button>
                        <button
                          type="button"
                          class="btn w-100"
                          :class="
                            !setting.ssr_account_password_change
                              ? 'btn-danger'
                              : 'btn-outline-danger'
                          "
                          @click="setAllowPasswordChange(false)"
                        >
                          <i class="ti ti-lock-off me-1"></i>
                          {{ $t("control.disabled") }}
                        </button>
                      </div>
                      <input
                        type="hidden"
                        name="allow_password_change"
                        :value="
                          setting.ssr_account_password_change
                            ? 'enabled'
                            : 'disabled'
                        "
                      />
                    </div>

                    <div class="col-12 col-md-6 mb-4">
                      <label class="form-label d-block">{{
                        $t("settings.allow_change_profile_using_balance")
                      }}</label>
                      <div class="d-flex gap-2 mt-2">
                        <button
                          type="button"
                          class="btn w-100"
                          :class="
                            setting.ssr_account_profile_update
                              ? 'btn-success'
                              : 'btn-outline-success'
                          "
                          @click="setAllowBalanceRenewal(true)"
                        >
                          <i class="ti ti-rotate-clockwise-2 me-1"></i>
                          {{ $t("control.enabled") }}
                        </button>
                        <button
                          type="button"
                          class="btn w-100"
                          :class="
                            !setting.ssr_account_profile_update
                              ? 'btn-danger'
                              : 'btn-outline-danger'
                          "
                          @click="setAllowBalanceRenewal(false)"
                        >
                          <i class="ti ti-ban me-1"></i>
                          {{ $t("control.disabled") }}
                        </button>
                      </div>
                      <input
                        type="hidden"
                        name="allow_balance_renewal"
                        :value="
                          setting.ssr_account_profile_update
                            ? 'enabled'
                            : 'disabled'
                        "
                      />
                    </div>

                    <div class="col-12 col-md-6 mb-4">
                      <label class="form-label d-block">{{
                        $t("settings.open_account_speed_3hours")
                      }}</label>
                      <div class="d-flex gap-2 mt-2">
                        <button
                          type="button"
                          class="btn w-100"
                          :class="
                            setting.ssr_account_open_speed_enabled
                              ? 'btn-success'
                              : 'btn-outline-success'
                          "
                          @click="setAllowOpenSpeed(true)"
                        >
                          <i class="ti ti-rotate-clockwise-2 me-1"></i>
                          {{ $t("control.enabled") }}
                        </button>
                        <button
                          type="button"
                          class="btn w-100"
                          :class="
                            !setting.ssr_account_open_speed_enabled
                              ? 'btn-danger'
                              : 'btn-outline-danger'
                          "
                          @click="setAllowOpenSpeed(false)"
                        >
                          <i class="ti ti-ban me-1"></i>
                          {{ $t("control.disabled") }}
                        </button>
                      </div>
                      <input
                        type="hidden"
                        name="allow_open_speed"
                        :value="
                          setting.ssr_account_open_speed_enabled
                            ? 'enabled'
                            : 'disabled'
                        "
                      />
                      <div
                        v-if="setting.ssr_account_open_speed_enabled"
                        class="mt-4"
                      >
                        <label class="form-label" for="open_speed_from">{{
                          $t("settings.open_speed_settings")
                        }}</label>
                        <div class="input-group">
                          <div class="input-group-text">
                            <i class="ti ti-clock"></i>
                          </div>
                          <select
                            v-model="setting.ssr_account_open_speed_speed"
                            id="open_speed_speed"
                            class="form-select"
                          >
                            <option
                              v-for="unit in [
                                { name: '5MB', id: '5120' },
                                { name: '10MB', id: '10240' },
                                { name: '15MB', id: '15360' },
                                { name: '20MB', id: '20480' },
                                { name: '25MB', id: '25600' },
                                { name: '50MB', id: '51200' },
                                { name: '100MB', id: '102400' },
                              ]"
                              v-bind:key="unit.id"
                              :value="unit.id"
                            >
                              {{ unit.name }}
                            </option>
                          </select>

                          <select
                            v-model="setting.ssr_account_open_speed_from"
                            id="open_speed_from"
                            class="form-select"
                            @change="validate"
                          >
                            <option
                              v-for="unit in [
                                { name: '00:00', id: '0' },
                                { name: '01:00', id: '1' },
                                { name: '02:00', id: '2' },
                                { name: '03:00', id: '3' },
                                { name: '04:00', id: '4' },
                                { name: '05:00', id: '5' },
                                { name: '06:00', id: '6' },
                                { name: '07:00', id: '7' },
                                { name: '08:00', id: '8' },
                                { name: '09:00', id: '9' },
                                { name: '10:00', id: '10' },
                                { name: '11:00', id: '11' },
                                { name: '12:00', id: '12' },
                                { name: '13:00', id: '13' },
                                { name: '14:00', id: '14' },
                                { name: '15:00', id: '15' },
                                { name: '16:00', id: '16' },
                                { name: '17:00', id: '17' },
                                { name: '18:00', id: '18' },
                                { name: '19:00', id: '19' },
                                { name: '20:00', id: '20' },
                                { name: '21:00', id: '21' },
                                { name: '22:00', id: '22' },
                                { name: '23:00', id: '23' },
                              ]"
                              v-bind:key="unit.id"
                              :value="unit.id"
                            >
                              {{ unit.name }}
                            </option>
                          </select>
                          <select
                            v-model="setting.ssr_account_open_speed_to"
                            id="open_speed_to"
                            class="form-select"
                            @change="validate"
                          >
                            <option
                              v-for="unit in [
                                { name: '00:00', id: '0' },
                                { name: '01:00', id: '1' },
                                { name: '02:00', id: '2' },
                                { name: '03:00', id: '3' },
                                { name: '04:00', id: '4' },
                                { name: '05:00', id: '5' },
                                { name: '06:00', id: '6' },
                                { name: '07:00', id: '7' },
                                { name: '08:00', id: '8' },
                                { name: '09:00', id: '9' },
                                { name: '10:00', id: '10' },
                                { name: '11:00', id: '11' },
                                { name: '12:00', id: '12' },
                                { name: '13:00', id: '13' },
                                { name: '14:00', id: '14' },
                                { name: '15:00', id: '15' },
                                { name: '16:00', id: '16' },
                                { name: '17:00', id: '17' },
                                { name: '18:00', id: '18' },
                                { name: '19:00', id: '19' },
                                { name: '20:00', id: '20' },
                                { name: '21:00', id: '21' },
                                { name: '22:00', id: '22' },
                                { name: '23:00', id: '23' },
                              ]"
                              v-bind:key="unit.id"
                              :value="unit.id"
                            >
                              {{ unit.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-md-6 mb-4">
                      <label class="form-label d-block">{{
                        $t("settings.double_account_speed")
                      }}</label>
                      <div class="d-flex gap-2 mt-2">
                        <button
                          type="button"
                          class="btn w-100"
                          :class="
                            setting.ssr_account_double_speed_enabled
                              ? 'btn-success'
                              : 'btn-outline-success'
                          "
                          @click="setAllowDoubleSpeed(true)"
                        >
                          <i class="ti ti-rotate-clockwise-2 me-1"></i>
                          {{ $t("control.enabled") }}
                        </button>
                        <button
                          type="button"
                          class="btn w-100"
                          :class="
                            !setting.ssr_account_double_speed_enabled
                              ? 'btn-danger'
                              : 'btn-outline-danger'
                          "
                          @click="setAllowDoubleSpeed(false)"
                        >
                          <i class="ti ti-ban me-1"></i>
                          {{ $t("control.disabled") }}
                        </button>
                      </div>
                      <input
                        type="hidden"
                        name="allow_double_speed"
                        :value="
                          setting.ssr_account_double_speed_enabled
                            ? 'enabled'
                            : 'disabled'
                        "
                      />
                      <div
                        v-if="setting.ssr_account_double_speed_enabled"
                        class="mt-4"
                      >
                        <label class="form-label" for="double_speed_from">{{
                          $t("settings.double_speed_times")
                        }}</label>
                        <div class="input-group">
                          <div class="input-group-text">
                            <i class="ti ti-clock"></i>
                          </div>

                          <select
                            v-model="setting.ssr_account_double_speed_from"
                            id="double_speed_from"
                            @change="validate"
                            class="form-select"
                          >
                            <option
                              v-for="unit in [
                                { name: '00:00', id: '0' },
                                { name: '01:00', id: '1' },
                                { name: '02:00', id: '2' },
                                { name: '03:00', id: '3' },
                                { name: '04:00', id: '4' },
                                { name: '05:00', id: '5' },
                                { name: '06:00', id: '6' },
                                { name: '07:00', id: '7' },
                                { name: '08:00', id: '8' },
                                { name: '09:00', id: '9' },
                                { name: '10:00', id: '10' },
                                { name: '11:00', id: '11' },
                                { name: '12:00', id: '12' },
                                { name: '13:00', id: '13' },
                                { name: '14:00', id: '14' },
                                { name: '15:00', id: '15' },
                                { name: '16:00', id: '16' },
                                { name: '17:00', id: '17' },
                                { name: '18:00', id: '18' },
                                { name: '19:00', id: '19' },
                                { name: '20:00', id: '20' },
                                { name: '21:00', id: '21' },
                                { name: '22:00', id: '22' },
                                { name: '23:00', id: '23' },
                              ]"
                              v-bind:key="unit.id"
                              :value="unit.id"
                            >
                              {{ unit.name }}
                            </option>
                          </select>
                          <select
                            v-model="setting.ssr_account_double_speed_to"
                            id="double_speed_to"
                            @change="validate"
                            class="form-select"
                          >
                            <option
                              v-for="unit in [
                                { name: '00:00', id: '0' },
                                { name: '01:00', id: '1' },
                                { name: '02:00', id: '2' },
                                { name: '03:00', id: '3' },
                                { name: '04:00', id: '4' },
                                { name: '05:00', id: '5' },
                                { name: '06:00', id: '6' },
                                { name: '07:00', id: '7' },
                                { name: '08:00', id: '8' },
                                { name: '09:00', id: '9' },
                                { name: '10:00', id: '10' },
                                { name: '11:00', id: '11' },
                                { name: '12:00', id: '12' },
                                { name: '13:00', id: '13' },
                                { name: '14:00', id: '14' },
                                { name: '15:00', id: '15' },
                                { name: '16:00', id: '16' },
                                { name: '17:00', id: '17' },
                                { name: '18:00', id: '18' },
                                { name: '19:00', id: '19' },
                                { name: '20:00', id: '20' },
                                { name: '21:00', id: '21' },
                                { name: '22:00', id: '22' },
                                { name: '23:00', id: '23' },
                              ]"
                              v-bind:key="unit.id"
                              :value="unit.id"
                            >
                              {{ unit.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="card mb-6">
              <div class="card-body">
                <form method="GET" onsubmit="return false">
                  <div class="row">
                    <h4 class="mt-4">{{ $t("settings.mikrotik_settings") }}</h4>
                    <div class="col-12 mb-4">
                      <label class="form-label" for="usageExchangeInterval">{{
                        $t("settings.mikrotik_interim_update")
                      }}</label>
                      <div class="input-group">
                        <div class="input-group-text">
                          <i class="ti ti-repeat"></i>
                        </div>
                        <select
                          v-model="setting.nas_interim_update"
                          id="usageExchangeInterval"
                          class="form-select"
                        >
                          <option value="1m">1m</option>
                          <option value="2m">2m</option>
                          <option value="5m">5m</option>
                          <option value="10m">10m</option>
                          <option value="30m">30m</option>
                          <option value="1h">1h</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-6 col-12">
            <div class="card mb-6">
              <div class="card-body">
                <form method="GET" onsubmit="return false">
                  <div class="row">
                    <h4 class="mt-4">{{ $t("settings.reseller_settings") }}</h4>
                    <div class="col-12  mb-4">
                      <label class="form-label" for="profitPercentage">{{
                        $t("settings.reseller_benefit_rate")
                      }}</label>
                      <div class="input-group">
                        <div class="input-group-text">
                          <i class="ti ti-percentage"></i>
                        </div>
                        <input
                          type="number"
                          id="profitPercentage"
                          name="profitPercentage"
                          class="form-control"
                          value="0"
                          min="0"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div> -->
          <div class="mt-3 d-flex justify-content-center">
            <button
              type="submit"
              class="btn btn-primary me-2 w-px-300"
              @click.prevent="submitSystemSettings"
              :disabled="loading || !validated"
              v-if="hasPrivilege('settings_update_settings')"
            >
              {{ $t("settings.save_changes") }}
            </button>
          </div>
        </div>

        <div
          class="row"
          v-show="activeTab === 'print'"
          v-if="hasPrivilege('settings_view_settings')"
        >
          <div class="col-12">
            <div class="card mb-6">
              <div class="card-body">
                <h4>
                  {{ $t("settings.print.additional_print_settings") }}
                </h4>
                <div class="row">
                  <div class="col-12 col-md-6 mb-4">
                    <div class="input-group">
                      <div class="input-group-text w-20">
                        <div>{{ $t("settings.print.network_logo") }}</div>
                      </div>
                      <select
                        v-model="setting.print.network_logo"
                        class="form-select"
                      >
                        <option :value="true">{{
                          $t("control.visible")
                        }}</option>
                        <option :value="false">{{
                          $t("control.hidden")
                        }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-4">
                    <div class="input-group">
                      <div class="input-group-text w-20">
                        <div>{{ $t("settings.print.network_name") }}</div>
                      </div>
                      <select
                        v-model="setting.print.network_name"
                        class="form-select"
                      >
                        <option :value="true">{{
                          $t("control.visible")
                        }}</option>
                        <option :value="false">{{
                          $t("control.hidden")
                        }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-4">
                    <div class="input-group">
                      <div class="input-group-text w-20">
                        <div>{{ $t("settings.print.address") }}</div>
                      </div>
                      <select
                        v-model="setting.print.address"
                        class="form-select"
                      >
                        <option :value="true">{{
                          $t("control.visible")
                        }}</option>
                        <option :value="false">{{
                          $t("control.hidden")
                        }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-4">
                    <div class="input-group">
                      <div class="input-group-text w-20">
                        <div>{{ $t("settings.print.phone") }}</div>
                      </div>
                      <select v-model="setting.print.phone" class="form-select">
                        <option :value="true">{{
                          $t("control.visible")
                        }}</option>
                        <option :value="false">{{
                          $t("control.hidden")
                        }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-4">
                    <div class="input-group">
                      <div class="input-group-text w-20">
                        <div>{{ $t("settings.print.phone_line") }}</div>
                      </div>
                      <select
                        v-model="setting.print.phone_line"
                        class="form-select"
                      >
                        <option :value="true">{{
                          $t("control.visible")
                        }}</option>
                        <option :value="false">{{
                          $t("control.hidden")
                        }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-4">
                    <div class="input-group">
                      <div class="input-group-text w-20">
                        <div>{{ $t("settings.print.issued_date") }}</div>
                      </div>
                      <select
                        v-model="setting.print.issued_date"
                        class="form-select"
                      >
                        <option :value="true">{{
                          $t("control.visible")
                        }}</option>
                        <option :value="false">{{
                          $t("control.hidden")
                        }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-4">
                    <div class="input-group">
                      <div class="input-group-text w-20">
                        <div>{{ $t("settings.print.account_id") }}</div>
                      </div>
                      <select
                        v-model="setting.print.account_id"
                        class="form-select"
                      >
                        <option :value="true">{{
                          $t("control.visible")
                        }}</option>
                        <option :value="false">{{
                          $t("control.hidden")
                        }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-4">
                    <div class="input-group">
                      <div class="input-group-text w-20">
                        <div>{{ $t("settings.print.bill_id") }}</div>
                      </div>
                      <select
                        v-model="setting.print.bill_id"
                        class="form-select"
                      >
                        <option :value="true">{{
                          $t("control.visible")
                        }}</option>
                        <option :value="false">{{
                          $t("control.hidden")
                        }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-4">
                    <div class="input-group">
                      <div class="input-group-text w-20">
                        <div>{{ $t("settings.print.bill_slug") }}</div>
                      </div>
                      <select
                        v-model="setting.print.bill_slug"
                        class="form-select"
                      >
                        <option :value="true">{{
                          $t("control.visible")
                        }}</option>
                        <option :value="false">{{
                          $t("control.hidden")
                        }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-4">
                    <div class="input-group">
                      <div class="input-group-text w-20">
                        <div>{{ $t("settings.print.profile") }}</div>
                      </div>
                      <select
                        v-model="setting.print.profile"
                        class="form-select"
                      >
                        <option :value="true">{{
                          $t("control.visible")
                        }}</option>
                        <option :value="false">{{
                          $t("control.hidden")
                        }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-4">
                    <div class="input-group">
                      <div class="input-group-text w-20">
                        <div>
                          {{ $t("settings.print.view_price_and_paid") }}
                        </div>
                      </div>
                      <select
                        v-model="setting.print.price_table"
                        class="form-select"
                      >
                        <option :value="true">{{
                          $t("settings.print.detailed_table")
                        }}</option>
                        <option :value="false">{{
                          $t("settings.print.price_only")
                        }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-4">
                    <div class="input-group">
                      <div class="input-group-text w-20">
                        <div>{{ $t("settings.print.signature") }}</div>
                      </div>
                      <select
                        v-model="setting.print.signature"
                        class="form-select"
                      >
                        <option :value="true">{{
                          $t("control.visible")
                        }}</option>
                        <option :value="false">{{
                          $t("control.hidden")
                        }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-3 d-flex justify-content-center">
            <button
              type="submit"
              class="btn btn-primary me-2 w-px-300"
              @click.prevent="submitPrintSettings"
              v-if="hasPrivilege('settings_update_settings')"
            >
              {{ $t("settings.save_changes") }}
            </button>
          </div>
        </div>
        <div
          class="row"
          v-if="settings.features.backups && hasPrivilege('settings_backup')"
          v-show="activeTab === 'backup'"
        >
          <div class="col-12">
            <div class="card mb-6">
              <div class="card-body">
                <div class="mt-3 d-flex justify-content-center">
                  <button
                    v-if="loading"
                    class="btn btn-lg btn-primary me-2 w-px-300"
                  >
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </button>
                  <button
                    v-else
                    type="button"
                    class="btn btn-lg btn-primary me-2 w-px-300"
                    @click.prevent="BackupNow"
                  >
                    <i class="ti ti-lg ti-database-import me-2"></i>
                    {{ $t("settings.backup_now") }}
                  </button>
                </div>
              </div>
              <div class="card-datatable">
                <div class="dataTables_wrapper dt-bootstrap5 no-footer">
                  <div class="dataTables_scroll" bis_skin_checked="1">
                    <div
                      class="dataTables_scrollBody table-container"
                      bis_skin_checked="1"
                      style="position: relative; overflow: auto; width: 100%;"
                    >
                      <table
                        class="dt-scrollableTable table dataTable no-footer table-hover border-top border-bottom dtr-column table-responsive"
                        id="DataTables_Table_0"
                        aria-describedby="DataTables_Table_0_info"
                        style="width: 1653px;"
                      >
                        <thead>
                          <tr class="text-nowrap">
                            <th class="sorting">{{ $t("settings.name") }}</th>
                            <th class="sorting">{{ $t("settings.action") }}</th>
                          </tr>
                        </thead>
                        <tbody class="table-border-bottom-0 ">
                          <tr v-for="(file, index) in file_names" :key="index">
                            <td>
                              <div class="text-primary">{{ file }}</div>
                            </td>
                            <td>
                              <div
                                class="d-flex justify-content-center align-items-center flex-md-row flex-column gap-2"
                              >
                                <a
                                  type="button"
                                  class="btn btn-primary me-2"
                                  :href="
                                    this.server_url + 'backup_files/' + file
                                  "
                                  download=""
                                >
                                  {{ $t("settings.download") }}
                                  <!-- <button
                              class="btn btn-primary me-2"
                              @click="downloadBackup(file)"
                              >
                              <i class="ti ti-download me-1"></i>
                              {{ $t("settings.download") }}
                              </button> -->
                                </a>
                                <button
                                  class="btn btn-label-danger"
                                  @click="confirmDeleteBackup(file)"
                                >
                                  <i class="ti ti-trash me-1"></i>
                                  {{ $t("settings.delete") }}
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="row"
          v-show="activeTab === 'restore'"
          v-if="hasPrivilege('settings_restore')"
        >
          <div class="col-12">
            <div class="card mb-6">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-md-3 mb-4">
                    <form
                      action="/upload"
                      class="dropzone needsclick dropzone-basic"
                      ssr_type="dma"
                      :class="{
                        disabled: file_ready != null && file_ready != 'dma',
                      }"
                    >
                      <div class="dz-message needsclick">
                        {{ $t("settings.file_from_dma") }}
                        <span class="note needsclick">{{
                          $t("settings.drop_files_or_click_to_upload")
                        }}</span>
                      </div>
                      <div class="fallback">
                        <input name="file" type="file" accept=".sql" />
                      </div>
                    </form>
                  </div>
                  <div class="col-12 col-md-3 mb-4">
                    <form
                      action="/upload"
                      class="dropzone needsclick dropzone-basic"
                      ssr_type="ssr"
                      :class="{
                        disabled: file_ready != null && file_ready != 'ssr',
                      }"
                    >
                      <div class="dz-message needsclick">
                        {{ $t("settings.file_from_ssr") }}
                        <span class="note needsclick">{{
                          $t("settings.drop_files_or_click_to_upload")
                        }}</span>
                      </div>
                      <div class="fallback">
                        <input name="file" type="file" accept=".sql" />
                      </div>
                    </form>
                  </div>
                  <div class="col-12 col-md-3 mb-4">
                    <form
                      action="/upload"
                      class="dropzone needsclick dropzone-basic"
                      ssr_type="nas"
                      :class="{
                        disabled: file_ready != null && file_ready != 'nas',
                      }"
                    >
                      <div class="dz-message needsclick">
                        {{ $t("settings.file_extracted_from_ssr_nas") }}
                        <span class="note needsclick">{{
                          $t("settings.drop_files_or_click_to_upload")
                        }}</span>
                      </div>
                      <div class="fallback">
                        <input name="file" type="file" accept=".sql" />
                      </div>
                    </form>
                  </div>
                  <div class="col-12 col-md-3 mb-4 border">
                    <form
                      action="/upload"
                      class="dropzone needsclick dropzone-basic"
                      ssr_type="rsc"
                      :class="{
                        disabled: file_ready != null && file_ready != 'rsc',
                      }"
                    >
                      <div class="dz-message needsclick">
                        {{ $t("settings.file_from_mikrotik") }}
                        <span class="note needsclick">{{
                          $t("settings.drop_files_or_click_to_upload")
                        }}</span>
                        <span class="note" dir="ltr">.rsc</span>
                      </div>
                      <div class="fallback">
                        <input name="file" type="file" accept=".rsc" />
                      </div>
                    </form>
                    <div
                      dir="ltr"
                      class="flex bg-gray-200 font-mono text-left border-2 border-black"
                    >
                      /ppp/secret/export file=secrets_export show-sensitive
                    </div>
                  </div>
                </div>
                <div class="mt-3 d-flex justify-content-center">
                  <button
                    :disabled="file_ready == null"
                    type="submit"
                    class="btn btn-primary me-2 w-px-300"
                    @click.prevent="beginRestore"
                  >
                    <i class="ti ti-download me-2"></i>
                    {{ $t("settings.import") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="row"
          v-show="activeTab === 'license'"
          v-if="hasPrivilege('settings_view_license')"
        >
          <div class="mt-3 d-flex justify-content-center">
            <button
              type="submit"
              class="btn btn-success me-2 mt-5 mb-5 w-px-300"
              @click.prevent="submitUpdateLicense"
            >
              <i class="ti ti-certificate me-2"></i>
              {{ $t("settings.update_license") }}
            </button>
          </div>
          <div class="col-12">
            <div class="card mb-6">
              <div class="card-body">
                <h4 class="mb-4">{{ $t("settings.device") }}</h4>
                <div class="row">
                  <div class="col-md-6 col-12 mb-4">
                    <label class="form-label">ID</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <i class="ti ti-device-laptop"></i>
                      </div>
                      <div class="form-control bg-light">{{ license.id }}</div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mb-4">
                    <label class="form-label">IP</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <i class="ti ti-world-www"></i>
                      </div>
                      <div class="form-control bg-light">{{ license.ip }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-6">
              <div class="card-body">
                <h4 class="mb-4">{{ $t("settings.subscription") }}</h4>
                <div class="row">
                  <div class="col-md-6 col-12 mb-4">
                    <label class="form-label">{{ $t("settings.realm") }}</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <i class="ti ti-server"></i>
                      </div>
                      <div class="form-control bg-light">
                        {{ license.realm }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mb-4">
                    <label class="form-label">{{
                      $t("settings.full_name")
                    }}</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <i class="ti ti-user"></i>
                      </div>
                      <div class="form-control bg-light">
                        {{ license.full_name }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mb-4">
                    <label class="form-label">{{ $t("settings.name") }}</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <i class="ti ti-user-circle"></i>
                      </div>
                      <div class="form-control bg-light">
                        {{ license.name }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mb-4">
                    <label class="form-label">{{
                      $t("settings.network")
                    }}</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <i class="ti ti-router"></i>
                      </div>
                      <div class="form-control bg-light">
                        {{ license.network }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mb-4">
                    <label class="form-label">{{ $t("settings.phone") }}</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <i class="ti ti-phone"></i>
                      </div>
                      <div class="form-control bg-light">
                        {{ license.phone }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mb-4">
                    <label class="form-label">{{ $t("settings.email") }}</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <i class="ti ti-mail"></i>
                      </div>
                      <div class="form-control bg-light">
                        {{ license.email }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mb-4">
                    <label class="form-label">{{
                      $t("settings.expires_at")
                    }}</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <i class="ti ti-clock"></i>
                      </div>
                      <div class="form-control bg-light">
                        {{ license.expires_at }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-6">
              <div class="card-body">
                <h4 class="mb-4">{{ $t("settings.plan") }}</h4>
                <div class="row">
                  <div class="col-md-6 col-12 mb-4">
                    <label class="form-label">{{
                      $t("settings.plan_name")
                    }}</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <i class="ti ti-badge"></i>
                      </div>
                      <div class="form-control bg-light">
                        {{ license.package_name }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mb-4">
                    <label class="form-label">{{
                      $t("settings.details")
                    }}</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <i class="ti ti-info-circle"></i>
                      </div>
                      <div class="form-control bg-light">
                        {{ license.package_details }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mb-4">
                    <label class="form-label">{{
                      $t("settings.duration_months")
                    }}</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <i class="ti ti-calendar-time"></i>
                      </div>
                      <div class="form-control bg-light">
                        {{ license.package_months }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mb-4">
                    <label class="form-label">{{
                      $t("settings.online_sessions_count")
                    }}</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <i class="ti ti-cloud-data-connection"></i>
                      </div>
                      <div class="form-control bg-light">
                        {{ license.package_online_count }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mb-4">
                    <label class="form-label">{{
                      $t("settings.nases_count")
                    }}</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <i class="ti ti-antenna-bars-5"></i>
                      </div>
                      <div class="form-control bg-light">
                        {{ license.package_nases_count }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mb-4">
                    <label class="form-label">{{
                      $t("settings.admins_count")
                    }}</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <i class="ti ti-shield-lock"></i>
                      </div>
                      <div class="form-control bg-light">
                        {{ license.package_admins_count }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mb-4">
                    <label class="form-label">{{
                      $t("settings.resellers_count")
                    }}</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <i class="ti ti-users-group"></i>
                      </div>
                      <div class="form-control bg-light">
                        {{ license.package_resellers_count }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="row"
          v-show="activeTab === 'updates'"
          v-if="hasPrivilege('settings_update')"
        >
          <div v-if="!up_to_date" class="col-12">
            <div class="card mb-6">
              <div class="card-body text-center">
                <div class="mb-3">
                  <h6
                    v-if="settings.type == 'local'"
                    class="d-flex justify-content-center align-items-center gap-2 mb-3"
                  >
                    {{ $t("settings.current_version") }}:
                    {{ settings.update_name }}
                  </h6>
                  <h3
                    class="d-flex justify-content-center align-items-center gap-2 text-success"
                  >
                    <i class="ti ti-xl ti-refresh "></i>
                    {{ $t("settings.new_update_available") }}
                  </h3>
                </div>

                <div class="row">
                  <div class="col-md-6 col-12 mb-4">
                    <h4 class=" d-block text-primary">
                      <i class="ti ti-lg ti-tag me-1"></i>
                      {{ $t("settings.update_name") }}
                    </h4>
                    <div
                      class="alert alert-primary px-3 py-2 d-inline-block w-100"
                    >
                      {{ update.name }}
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mb-4">
                    <h4 class=" d-block text-info">
                      <i class="ti ti-lg ti-notes me-1"></i>
                      {{ $t("settings.change_log") }}
                    </h4>
                    <div
                      class="alert alert-info px-3 py-2 d-inline-block text-start w-100"
                      style="min-width: 300px;"
                    >
                      <ul class="mb-0 ps-3 w-100">
                        <li>{{ update.change_log }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-success px-4"
                  @click="downloadAndInstallUpdate"
                >
                  <i class="ti ti-download me-2"></i>
                  {{ $t("settings.download_and_install") }}
                </button>
              </div>
            </div>
          </div>
          <div v-if="up_to_date" class="col-12">
            <div class="card mb-6">
              <div class="card-body text-center">
                <h6
                  v-if="settings.type == 'local'"
                  class="d-flex justify-content-center align-items-center gap-2 mb-3"
                >
                  {{ $t("settings.current_version") }}:
                  {{ settings.update_name }}
                </h6>
                <h3
                  class="d-flex justify-content-center align-items-center gap-2 alert alert-success mb-0"
                >
                  <i class="ti ti-xl ti-progress-check "></i>
                  {{ $t("settings.super_speed_radius_is_up_to_date") }}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Resumable from "resumablejs";
import { hasPrivilege } from "../global_constants";
export default {
  computed: {
    ...mapGetters(["settings", "user"]),
  },
  data() {
    return {
      activeTab: localStorage.getItem("activeSystemTab") || "system",
      tabs: [
        {
          id: "system",
          label: this.$t("sidebar.settings.system_settings"),
          icon: "ti ti-settings",
          privilege: this.hasPrivilege("settings_view_settings"),
        },
        {
          id: "print",
          label: this.$t("sidebar.settings.print_settings"),
          icon: "ti ti-printer",
          privilege: this.hasPrivilege("settings_view_settings"),
        },
        {
          id: "backup",
          label: this.$t("sidebar.settings.backup"),
          icon: "ti ti-database-import",
          privilege: this.hasPrivilege("settings_backup"),
        },
        {
          id: "restore",
          label: this.$t("sidebar.settings.restore"),
          icon: "ti ti-database-export",
          privilege: this.hasPrivilege("settings_restore"),
        },
        {
          id: "license",
          label: this.$t("sidebar.settings.license"),
          icon: "ti ti-certificate",
          privilege: this.hasPrivilege("settings_view_license"),
        },
        {
          id: "updates",
          label: this.$t("sidebar.settings.updates"),
          icon: "ti ti-refresh",
          privilege: this.hasPrivilege("settings_update"),
        },
      ],
      auto_backup_enabled: false,
      allow_password_change: false,
      allow_balance_renewal: false,
      backups: [
        "2025-04-19_01-30-37_small.sql",
        "2025-04-20_01-30-25_small.sql",
        "2025-04-21_01-30-40_small.sql",
        "2025-04-22_01-30-27_small.sql",
        "2025-04-23_01-30-10_small.sql",
        "2025-04-23_16-19-24.sql",
      ],
      error: "",
      message: "",
      currentImageUrl: null,
      setting: {
        network_name: "",
        network_logo: "",
        currency: "",
        language: "",
        time_zone: "",
        auto_backup: false,
        default_expiration_hour: "0",
        ssr_account_password_change: false,
        ssr_account_profile_update: false,
        ssr_account_open_speed_from: "0",
        ssr_account_open_speed_to: "6",
        ssr_account_open_speed_enabled: false,
        ssr_account_double_speed_from: "21",
        ssr_account_double_speed_to: "9",
        ssr_account_double_speed_enabled: false,
        ssr_account_open_speed_speed: 10240,
        nas_interim_update: "",
        benefit_rate: "25",
        print: {
          network_logo: true,
          network_name: true,
          address: true,
          phone: true,
          phone_line: true,
          issued_date: true,
          account_id: true,
          bill_id: true,
          bill_slug: true,
          profile: true,
          price_table: true,
          signature: true,
        },
      },
      license: {
        id: "1234567890",
        ip: "",
      },
      file_names: [],
      server_url: localStorage.getItem("server"),
      error_message: "",
      loading: false,
      profiles: null,
      update: {
        name: "",
        url: "",
        change_log: "",
        count: "",
        version: -1,
      },
      up_to_date: true,
      resumable_nas: new Resumable({
        target: localStorage.getItem("server_api") + "res/upload",
        fileType: ["sql", "rsc"],
        chunkSize: 1 * 1024 * 1024 * 20,
        testChunks: false,
        throttleProgressCallbacks: 1,
        simultaneousUploads: 3,
        permanentErrors: [419, 500, 210],
        headers: {
          Accept: "application/json",
        },
        withCredentials: true,
      }),
      sessions: false,
      clean: false,
      file_ready: null,
      file_uploaded: false,
      uploading: false,
      uploading_message: "",
      validated: true,
      errors: {
        ssr_account_open_speed: null,
        ssr_account_double_speed: null,
      },
    };
  },
  async created() {
    this.loading = true;
    if (this.hasPrivilege("settings_view_settings")) {
      const response = await axios.get("settings");
      if (response.status == 200) {
        this.setting = response.data.data;
        this.loading = false;
        if (this.setting.auto_backup == "true") {
          this.setting.auto_backup = true;
        } else {
          this.setting.auto_backup = false;
        }
        this.setting.ssr_account_password_change =
          this.setting.ssr_account_password_change == "1";
        this.setting.ssr_account_profile_update =
          this.setting.ssr_account_profile_update == "1";
        this.setting.ssr_account_open_speed_enabled =
          this.setting.ssr_account_open_speed_enabled == "1";
        this.setting.ssr_account_double_speed_enabled =
          this.setting.ssr_account_double_speed_enabled == "1";
      }
    }
    if (this.hasPrivilege("settings_backup")) {
      const response2 = await axios.get("backups");
      this.file_names = response2.data.files;
    }
    if (this.hasPrivilege("settings_view_license")) {
      this.fetchLicense();
    }
    if (this.hasPrivilege("settings_update") && this.settings.type == "local") {
      this.fetchUpdate();
    }
    if (this.hasPrivilege("settings_restore")) {
      await this.$nextTick();
      this.initUploaders();
    }
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    setActiveTab(tabId) {
      this.activeTab = tabId;
      localStorage.setItem("activeSystemTab", tabId);
    },
    setAutoBackup(status) {
      this.setting.auto_backup = status;
    },
    setAllowPasswordChange(status) {
      this.setting.ssr_account_password_change = status;
    },
    setAllowBalanceRenewal(status) {
      this.setting.ssr_account_profile_update = status;
    },
    setAllowOpenSpeed(status) {
      this.setting.ssr_account_open_speed_enabled = status;
    },
    setAllowDoubleSpeed(status) {
      this.setting.ssr_account_double_speed_enabled = status;
    },
    selectImage() {
      this.setting.network_logo = this.$refs.imageFile.files.item(0);
      this.currentImageUrl = URL.createObjectURL(this.setting.network_logo);
    },
    async fetchLicense() {
      this.loading = true;
      const response = await axios.get("settings/license");
      if (response.status == 200) {
        this.license = response.data.data;
      }
      this.loading = false;
    },
    async fetchUpdate() {
      this.loading = true;
      const update_status = await axios.get("settings/update/check");
      if (update_status.status == 200) {
        if (update_status.data.update == "yes") {
          this.update.name = update_status.data.data.name;
          this.update.url = update_status.data.data.url;
          this.update.change_log = update_status.data.data.change_log;
          this.update.version = update_status.data.data.id;
          this.update.count = update_status.data.count;
          this.up_to_date = false;
        } else {
          this.up_to_date = true;
        }
      }
      this.loading = false;
    },
    async submitSystemSettings() {
      try {
        this.loading = true;
        const data = new FormData();
        data.append("network_logo", this.setting.network_logo);
        data.append("network_name", this.setting.network_name);
        data.append("currency", this.setting.currency);
        data.append("language", this.setting.language);
        data.append("time_zone", this.setting.time_zone);
        data.append("status_url", this.setting.status_url);
        data.append("phone_number", this.setting.phone_number);
        data.append(
          "ssr_account_password_change",
          this.setting.ssr_account_password_change ? "true" : "false",
        );
        data.append(
          "ssr_account_profile_update",
          this.setting.ssr_account_profile_update ? "true" : "false",
        );
        data.append(
          "ssr_account_open_speed_enabled",
          this.setting.ssr_account_open_speed_enabled ? "true" : "false",
        );
        data.append(
          "ssr_account_open_speed_from",
          this.setting.ssr_account_open_speed_from,
        );
        data.append(
          "ssr_account_open_speed_to",
          this.setting.ssr_account_open_speed_to,
        );
        data.append(
          "ssr_account_open_speed_speed",
          this.setting.ssr_account_open_speed_speed,
        );
        data.append(
          "ssr_account_double_speed_enabled",
          this.setting.ssr_account_double_speed_enabled ? "true" : "false",
        );
        data.append(
          "ssr_account_double_speed_from",
          this.setting.ssr_account_double_speed_from,
        );
        data.append(
          "ssr_account_double_speed_to",
          this.setting.ssr_account_double_speed_to,
        );
        data.append(
          "default_expiration_hour",
          this.setting.default_expiration_hour,
        );
        data.append("auto_backup", this.setting.auto_backup ? "true" : "false");
        data.append("nas_interim_update", this.setting.nas_interim_update);
        // data.append("benefit_rate", this.setting.benefit_rate);
        const response = await axios.post("/settings/update", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (response.status == 200) {
          const responseSettings = await axios.get("settings");
          this.$store.dispatch("settings", responseSettings.data.data);
          this.$router.push({ path: "/", query: { success: "success" } });
        }
        this.$swal({
          icon: "success",
          title: "Changes saved successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Failed to save changes",
          text:
            error.response?.data?.message ||
            this.$t("control.some_thing_went_wrong_please_try_again"),
          confirmButtonText: "OK",
        });
      }
    },
    async submitPrintSettings() {
      try {
        this.loading = true;
        const response = await axios.post(
          "/settings/update/print",
          this.setting.print,
        );
        if (response.status == 200) {
          const responseSettings = await axios.get("settings");
          this.$store.dispatch("settings", responseSettings.data.data);
        }
        this.$swal({
          icon: "success",
          title: "Changes saved successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Failed to save changes",
          text:
            error.response?.data?.message ||
            this.$t("control.some_thing_went_wrong_please_try_again"),
          confirmButtonText: "OK",
        });
      }
    },
    confirmDeleteBackup(file) {
      this.$swal({
        title: "Are you sure?",
        html: `You are about to delete:<br><div class="text-primary mt-1"> ${file}</div>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-label-secondary",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await axios.delete("backup/" + file);
          if (response.status == 200) {
            const response2 = await axios.get("backups");
            this.file_names = response2.data.files;
          }
          this.$swal({
            icon: "success",
            title: "Deleted!",
            html: `<div class="text-primary mb-n4"> ${file}</div> <br> has been deleted.`,
            timer: 1500,
            showConfirmButton: false,
          });
        }
      });
    },
    async BackupNow() {
      try {
        this.loading = true;
        this.message = this.$t("messages.backup.backuping");
        const response = await axios.post("backup");
        if (response.status != 200) {
          this.message = this.$t("errors.backup.backuping");
          return;
        }
        this.loading = false;
        this.$swal({
          icon: "success",
          title: "Backup Created Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        const response2 = await axios.get("backups");
        this.file_names = response2.data.files;

        // this.$router.push({ path: "/dashboard", query: { status: "suceess" } });
      } catch (error) {
        this.message = this.$t("messages.restore.server");
        this.$swal({
          icon: "error",
          title: "Backup Failed",
          text:
            "An error occurred while creating the backup. Please try again.",
          confirmButtonText: "OK",
        });
      }
    },
    submitImport() {
      const failed = false;

      if (failed) {
        this.$swal({
          icon: "error",
          title: "Import Failed",
          text: "An error occurred during import. Please try again.",
          confirmButtonText: "OK",
        });
      } else {
        this.$swal({
          icon: "success",
          title: "Import Successful",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    async submitUpdateLicense() {
      const failed = false;
      try {
        this.loading = true;
        const curr_url = window.location.origin;
        if (
          curr_url == "http://localhost:8080" ||
          curr_url == "https://s1.ssradius.com" ||
          curr_url == "https://s2.ssradius.com" ||
          curr_url == "https://s3.ssradius.com"
        ) {
          this.loading = false;
          return;
        }
        const response = await axios.get("update");
        if (response.status == 210) {
          license_error = this.$t("licnese_update_error");
          this.$swal({
            icon: "error",
            title: "Failed to update license",
            text: this.$t("licnese_update_error"),
            confirmButtonText: "OK",
          });
        }
        if (response.status == 200) {
          license_success = this.$t("licnese_update_success");
          this.$swal({
            icon: "success",
            title: "License updated successfully",
            showConfirmButton: false,
            timer: 1500,
          });
        }
        license_error = this.loading = false;
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Failed to update license",
          text: this.$t("licnese_update_error"),
          confirmButtonText: "OK",
        });
      }
      if (failed) {
      } else {
      }
    },
    async downloadAndInstallUpdate() {
      try {
        this.$swal.fire({
          title: "Downloading Update...",
          text: "Please wait while the update is being downloaded.",
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        const down_response = await axios.post(
          "settings/update/download",
          this.update,
        );
        if (down_response.status == 210) {
          this.$swal.fire({
            icon: "error",
            title: "Update Failed",
            text: this.$t("updates.downloading_fail"),
            confirmButtonText: "OK",
          });
          return;
        }
        this.$swal.fire({
          title: "Installing Update...",
          text: "Please wait while the update is being installed.",
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        const update_response = await axios.post(
          "settings/update/update",
          this.update,
        );
        if (update_response.status == 210) {
          this.$swal.fire({
            icon: "error",
            title: "Update Failed",
            text: this.$t("updates.installing_fail"),
            confirmButtonText: "OK",
          });
          return;
        }
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Update Failed",
          text: "An error occurred during the update. Please try again.",
          confirmButtonText: "OK",
        });
      }
      this.$swal.fire({
        icon: "success",
        title: "Update Installed",
        text: "The system has been successfully updated!",
        timer: 1500,
        showConfirmButton: false,
      });
      window.location.reload();
    },
    initUploaders() {
      const previewTemplate = `<div class="dz-preview dz-file-preview">
<div class="dz-details">
  <div class="dz-thumbnail">
    <img data-dz-thumbnail>
    <span class="dz-nopreview">No preview</span>
    <div class="dz-success-mark"></div>
    <div class="dz-error-mark"></div>
    <div class="dz-error-message"><span data-dz-errormessage></span></div>
    <div class="progress">
      <div class="progress-bar progress-bar-primary" role="progressbar" aria-valuemin="0" aria-valuemax="100" data-dz-uploadprogress></div>
    </div>
  </div>
  <div class="dz-filename" data-dz-name></div>
  <div class="dz-size" data-dz-size></div>
</div>
</div>`;

      const dropzoneConfigs = [
        { selector: ".dropzone-basic", options: { maxFiles: 1 } },
        { selector: ".dropzone-multi", options: {} },
      ];

      let resumable_nas = this.resumable_nas;
      let _this = this;
      dropzoneConfigs.forEach(({ selector, options }) => {
        document.querySelectorAll(selector).forEach((el) => {
          if (!el.classList.contains("dz-clickable")) {
            new Dropzone(el, {
              url: el.getAttribute("action") || "/upload",
              previewTemplate,
              parallelUploads: 1,
              maxFilesize: 7000,
              addRemoveLinks: true,
              acceptedFiles: ".sql,.rsc",
              init: function() {
                this.on("addedfile", function(file) {
                  console.log("A file has been added");
                  _this.file_ready = el.getAttribute("ssr_type");
                  resumable_nas.addFile(file);
                });
                this.on("removedfile", function(file) {
                  _this.file_ready = null;
                  console.log("File removed: " + file.name);

                  resumable_nas.removeFile(file);
                });
              },
              ...options,
            });
          }
        });
      });
      this.initResumable();
    },
    updateProgress(state, value) {
      this.message = value;
      this.uploading = true;
      this.uploading_message = "uploading ... " + value;
      if (document.getElementById("swal_progress")) {
        document.getElementById("swal_progress").innerHTML = value;
      }
      if (value == "ready") {
        this.uploading_message = "ready %100";
        this.file_uploaded = true;
      } else if (value == "fail") {
        this.file_ready = null;
        this.uploading_message = "fail !!";
      }
    },
    initResumable() {
      let updateProgress = this.updateProgress;
      let r = this.resumable_nas;
      let uploading_message = this.uploading_message;
      let swal = this.$swal;
      const uploading_file_message = this.$t("settings.uploading_file");
      const file_uploaded_message = this.$t("settings.file_uploaded");
      const file_uploaded_successfully_message = this.$t(
        "settings.file_uploaded_successfully",
      );
      r.on("fileAdded", function(file, event) {
        swal.fire({
          title: uploading_file_message,
          html: "<span id='swal_progress' ref='swal_progress'>%0</span>",
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            swal.showLoading();
          },
        });
        updateProgress(true, "%0");
        r.upload();
      });
      r.on("fileProgress", function(file, event) {
        updateProgress(true, "%" + Math.floor(file.progress() * 100));
      });
      r.on("fileSuccess", function(file, message) {
        updateProgress(false, "ready");
        swal.fire({
          icon: "success",
          title: file_uploaded_message,
          text: file_uploaded_successfully_message,
          timer: 1500,
          showConfirmButton: false,
        });
      });
      r.on("fileError", function(file, message) {
        updateProgress(false, "fail");
        this.$swal.fire({
          icon: "error",
          title: "Fail",
          text: "An Error occured while uploading please try again",
          confirmButtonText: "OK",
        });
      });
    },
    async beginRestore() {
      try {
        this.loading = true;
        this.message = this.$t("messages.restore.parsing");
        let accepted = true;
        if (this.file_ready == "dma") {
          const { value: formValues } = await this.$swal.fire({
            title: "Restore Options",
            html: `
            <div>
              <div class="col-12">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="clean"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-eraser"></i>
                        <span class="custom-option-title">
                          ${this.$t("restore.clean_restore")}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value="false"
                        id="clean"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="sessions"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-server"></i>
                        <span class="custom-option-title">
                          ${this.$t("restore.restore_radacct")}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value="false"
                        id="sessions"
                      />
                    </label>
                  </div>
                </div>
              </div>
  `,
            focusConfirm: false,
            preConfirm: () => {
              return {
                clean: document.getElementById("clean").checked,
                sessions: document.getElementById("sessions").checked,
              };
            },
          });
          this.sessions = formValues.sessions;
          this.clean = formValues.clean;
          if (this.sessions == true) {
            await this.$swal({
              title: this.$t("control.are_you_sure"),
              text: this.$t("restore.warning_radacct"),
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: this.$t("control.yes"),
              cancelButtonText: this.$t("control.cancel"),
              reverseButtons: true,
              customClass: {
                confirmButton: "btn btn-danger",
                cancelButton: "btn btn-label-secondary",
              },
              buttonsStyling: false,
            }).then((result) => {
              if (result.isConfirmed) {
                accepted = true;
              } else {
                accepted = false;
              }
            });
          }
        }
        if (accepted == false) {
          return;
        }
        this.$swal.fire({
          title: this.$t("messages.restore.parsing"),
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var response2;
        if (this.file_ready == "dma") {
          response2 = await axios.post("dma/restore", {
            sessions: this.sessions,
            clean: this.clean,
            file_name: this.resumable_nas.files[0].fileName,
          });
        } else if (this.file_ready == "ssr") {
          response2 = await axios.post("import", {
            file_name: this.resumable_nas.files[0].fileName,
          });
        } else if (this.file_ready == "nas") {
          response2 = await axios.post("nases/import", {
            file_name: this.resumable_nas.files[0].fileName,
          });
        } else if (this.file_ready == "rsc") {
          response2 = await axios.post("nases/rsc/import", {
            file_name: this.resumable_nas.files[0].fileName,
          });
        }
        console.log(response2.status);

        if (response2.status != 200) {
          this.message = this.$t("errors.restore.parsing");
          if (response2.status == 210) {
            this.message = response2.data.error;
          }
          this.$swal.fire({
            icon: "error",
            title: this.$t("errors.restore.parsing"),
            text: this.message,
          });
          return;
        }
        this.$swal.fire({
          title: this.$t("messages.restore.cleaning"),
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        const response3 = await axios.post("dma/flush");
        if (response3.status != 200) {
          this.message = this.$t("errors.restore.cleaning");
        }
        this.$swal.fire({
          icon: "success",
          title: this.$t("settings.data_imported"),
          text: this.$t("settings.data_imported_successfully"),
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Fail",
          text:
            error.response?.data?.message ||
            this.$t("control.some_thing_went_wrong_please_try_again"),
          timer: 1500,
          showConfirmButton: false,
        });
        console.log(error);

        this.message = this.$t("errors.restore.server");
      }
    },
    validate() {
      this.validated = true;
      // if (
      //   this.setting.ssr_account_double_speed_from >=
      //   this.setting.ssr_account_double_speed_to
      // ) {
      //   this.validated = false;
      //   this.errors.ssr_account_double_speed = this.$t(
      //     "settings.double_speed_time_error",
      //   );
      // }
      // if (
      //   this.setting.ssr_account_open_speed_from >=
      //   this.setting.ssr_account_open_speed_to
      // ) {
      //   this.validated = false;
      //   this.errors.ssr_account_open_speed = this.$t(
      //     "settings.open_speed_time_error",
      //   );
      // }
    },
  },
};
</script>
